export const CANCEL_RESULT_PLACEHOLDER = {
  data: [{ "": "Query execution has been canceled.", No: 1 }],
  meta: [
    {
      name: "No",
      type: "",
      displayName: "No",
    },
    {
      name: "",
      type: "string",
      displayName: "",
    },
  ],
  rows: 1,
};

export const CANCEL_RESULT_PLACEHOLDER_WITH_NETWORK_ERROR = {
  data: [
    {
      "": "Query execution has been canceled due to a network interruption.",
      Status: "Cancelled",
    },
  ],
  meta: [
    {
      name: "Status",
      type: "",
      displayName: "Status",
    },
    {
      name: "",
      type: "string",
      displayName: "",
    },
  ],
  rows: 1,
};
